// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file api/v1/user.proto (package api.v1, syntax proto3)
/* eslint-disable */

import type {
  GenFile,
  GenMessage,
  GenService,
} from "@bufbuild/protobuf/codegenv1";
import {
  fileDesc,
  messageDesc,
  serviceDesc,
} from "@bufbuild/protobuf/codegenv1";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import {
  file_google_protobuf_empty,
  file_google_protobuf_field_mask,
  file_google_protobuf_timestamp,
} from "@bufbuild/protobuf/wkt";
import type { PaginationMetadata } from "./common_pb";
import { file_api_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/user.proto.
 */
export const file_api_v1_user: GenFile =
  /*@__PURE__*/
  fileDesc(
    "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",
    [
      file_google_protobuf_empty,
      file_google_protobuf_timestamp,
      file_google_protobuf_field_mask,
      file_api_v1_common,
    ],
  );

/**
 * UserProfile contém os dados públicos e seguros para serem retornados pela API.
 *
 * @generated from message api.v1.UserProfile
 */
export type UserProfile = Message<"api.v1.UserProfile"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string uuid = 2;
   */
  uuid: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * @generated from field: string avatar = 5;
   */
  avatar: string;

  /**
   * @generated from field: google.protobuf.Timestamp birthday = 6;
   */
  birthday?: Timestamp;

  /**
   * @generated from field: string full_name = 7;
   */
  fullName: string;

  /**
   * @generated from field: double balance = 8;
   */
  balance: number;

  /**
   * @generated from field: int32 level = 9;
   */
  level: number;

  /**
   * @generated from field: string sponsor_uuid = 10;
   */
  sponsorUuid: string;

  /**
   * @generated from field: bool has_network = 11;
   */
  hasNetwork: boolean;

  /**
   * @generated from field: string code = 12;
   */
  code: string;

  /**
   * @generated from field: double total_earnings = 13;
   */
  totalEarnings: number;

  /**
   * @generated from field: double affiliate_earnings = 14;
   */
  affiliateEarnings: number;

  /**
   * Campos agregados (geralmente de views ou joins)
   *
   * @generated from field: string sponsor_email = 20;
   */
  sponsorEmail: string;

  /**
   * @generated from field: int32 network_level = 21;
   */
  networkLevel: number;

  /**
   * @generated from field: int64 active_stakes_count = 22;
   */
  activeStakesCount: bigint;

  /**
   * @generated from field: double active_stakes_sum = 23;
   */
  activeStakesSum: number;

  /**
   * @generated from field: int64 inactive_stakes_count = 24;
   */
  inactiveStakesCount: bigint;

  /**
   * @generated from field: double inactive_stakes_sum = 25;
   */
  inactiveStakesSum: number;

  /**
   * @generated from field: int64 active_licences_count = 26;
   */
  activeLicencesCount: bigint;

  /**
   * @generated from field: double active_licences_sum = 27;
   */
  activeLicencesSum: number;

  /**
   * @generated from field: int64 inactive_licences_count = 28;
   */
  inactiveLicencesCount: bigint;

  /**
   * @generated from field: double inactive_licences_sum = 29;
   */
  inactiveLicencesSum: number;

  /**
   * @generated from field: string createdAt = 7;
   */
  createdAt: string;
};

/**
 * Describes the message api.v1.UserProfile.
 * Use `create(UserProfileSchema)` to create a new message.
 */
export const UserProfileSchema: GenMessage<UserProfile> =
  /*@__PURE__*/
  messageDesc(file_api_v1_user, 0);

/**
 * User representa a entidade completa no banco de dados.
 *
 * @generated from message api.v1.User
 */
export type User = Message<"api.v1.User"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string uuid = 2;
   */
  uuid: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * @generated from field: string password_hash = 5;
   */
  passwordHash: string;

  /**
   * @generated from field: string avatar = 6;
   */
  avatar: string;

  /**
   * @generated from field: google.protobuf.Timestamp birthday = 7;
   */
  birthday?: Timestamp;

  /**
   * @generated from field: string full_name = 8;
   */
  fullName: string;

  /**
   * @generated from field: string cpf = 9;
   */
  cpf: string;

  /**
   * @generated from field: double balance = 10;
   */
  balance: number;

  /**
   * @generated from field: int32 level = 11;
   */
  level: number;

  /**
   * @generated from field: string sponsor_uuid = 12;
   */
  sponsorUuid: string;

  /**
   * @generated from field: bool has_network = 13;
   */
  hasNetwork: boolean;

  /**
   * @generated from field: string code = 14;
   */
  code: string;
};

/**
 * Describes the message api.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> =
  /*@__PURE__*/
  messageDesc(file_api_v1_user, 1);

/**
 * @generated from message api.v1.GetUserRequest
 */
export type GetUserRequest = Message<"api.v1.GetUserRequest"> & {
  /**
   * @generated from oneof api.v1.GetUserRequest.identifier
   */
  identifier:
    | {
        /**
         * @generated from field: int32 id = 1;
         */
        value: number;
        case: "id";
      }
    | {
        /**
         * @generated from field: string uuid = 2;
         */
        value: string;
        case: "uuid";
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message api.v1.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_user, 2);

/**
 * @generated from message api.v1.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"api.v1.UpdateUserRequest"> & {
  /**
   * @generated from field: api.v1.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message api.v1.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_user, 3);

/**
 * @generated from message api.v1.ListUsersRequest
 */
export type ListUsersRequest = Message<"api.v1.ListUsersRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Para buscar por nome, email, etc.
   *
   * @generated from field: optional string search_query = 3;
   */
  searchQuery?: string;
};

/**
 * Describes the message api.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_user, 4);

/**
 * @generated from message api.v1.ListUsersResponse
 */
export type ListUsersResponse = Message<"api.v1.ListUsersResponse"> & {
  /**
   * @generated from field: repeated api.v1.UserProfile users = 1;
   */
  users: UserProfile[];

  /**
   * @generated from field: api.v1.PaginationMetadata meta = 2;
   */
  meta?: PaginationMetadata;
};

/**
 * Describes the message api.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse> =
  /*@__PURE__*/
  messageDesc(file_api_v1_user, 5);

/**
 * @generated from message api.v1.ListUserNetworkRequest
 */
export type ListUserNetworkRequest =
  Message<"api.v1.ListUserNetworkRequest"> & {
    /**
     * @generated from field: int32 user_id = 1;
     */
    userId: number;

    /**
     * @generated from field: int32 page = 2;
     */
    page: number;

    /**
     * @generated from field: int32 page_size = 3;
     */
    pageSize: number;
  };

/**
 * Describes the message api.v1.ListUserNetworkRequest.
 * Use `create(ListUserNetworkRequestSchema)` to create a new message.
 */
export const ListUserNetworkRequestSchema: GenMessage<ListUserNetworkRequest> =
  /*@__PURE__*/
  messageDesc(file_api_v1_user, 6);

/**
 * @generated from service api.v1.UserService
 */
export const UserService: GenService<{
  /**
   * @generated from rpc api.v1.UserService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof UserProfileSchema;
  };
  /**
   * @generated from rpc api.v1.UserService.GetMyProfile
   */
  getMyProfile: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof UserProfileSchema;
  };
  /**
   * @generated from rpc api.v1.UserService.UpdateProfile
   */
  updateProfile: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UserProfileSchema;
  };
  /**
   * @generated from rpc api.v1.UserService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof ListUsersResponseSchema;
  };
  /**
   * @generated from rpc api.v1.UserService.GetUserSponsorChain
   */
  getUserSponsorChain: {
    methodKind: "unary";
    input: typeof ListUserNetworkRequestSchema;
    output: typeof ListUsersResponseSchema;
  };
  /**
   * @generated from rpc api.v1.UserService.GetUserSponsoredChain
   */
  getUserSponsoredChain: {
    methodKind: "unary";
    input: typeof ListUserNetworkRequestSchema;
    output: typeof ListUsersResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_api_v1_user, 0);
